// vim: ft=javascriptreact
import {
  Card,
  Col,
  Button,
  Row,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const Success = ({ date, officialUse, isConfirmed }) => {
  const navigate = useNavigate()

  return (
    <Row>
      <Col md={{ span: 6, offset: 3 }}>
        <Card>
          <Card.Header>
            <i className="fa fa-circle-check" />
          </Card.Header>
          <Card.Body className="text-center">
            <p className="lead">Room Booking {isConfirmed ? 'Confirmed' : 'Requested'} For {date}</p>
            {officialUse && (
              <p>The booking is confirmed.</p>
            )}
            {!officialUse && isConfirmed && (
              <p>A credit was found on your account, so the booking has been automatically-confirmed. A confirmation email has been sent to you.</p>
            )}
            {!isConfirmed && (
              <p>Once the preauthorized debit has been processed, you will receive a confirmation email.</p>
            )}

            <Button variant="outline-secondary" className="me-2" onClick={() => navigate('/schedule')}>
              Back to Schedule
            </Button>

            <Button variant="outline-secondary" onClick={() => navigate('/')}>
              Back to My Bookings
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default Success
